import { RESOURCE_TYPE } from '../../utils/constants';

// AUTH ENDPOINTS
export const login = '/auth/login';
export const resetPassword = '/auth/reset-password';

//USER MGMT ENDPOINTS
export const getUserInfo = '/user/me';
export const getFollowedProjectsCount = '/project/following-count';
export const acceptSuperPollutantsTerms = '/user/super-pollutants-terms/accept';

// EMAIL VERIFICATION ENDPOINTS
export const sendVerificationOtp = '/user/otp/send';
export const resendVerificationOtp = '/user/otp/resend';
export const verifyEmailOtp = '/user/otp/verify';

//DASHBOARD ENDPOINTS
export const dashboardProjects = '/project/dashboard';
export const dashboardGraph = '/project/dashboard-graph';

//ASSETS
export const assetBaseUrl = process.env.ASSET_BASE_URL;
export const assetBaseUrl2 = process.env.ASSET_BASE_URL2;
export const getVendorLogoURL = (slug: string) =>
  `${assetBaseUrl}/public/img/vendor_logos/${encodeURIComponent(slug)}`;

export const getAssetURL = (slug: string, type?: string) => {
  if (type === RESOURCE_TYPE) {
    return `${assetBaseUrl}/assets/files/resources/${encodeURIComponent(decodeURIComponent(slug))}`;
  } else {
    return `${assetBaseUrl}/assets/images/blog/${encodeURIComponent(decodeURIComponent(slug))}`;
  }
};

export const getRatingUrl = (slug: string) => {
  return `${assetBaseUrl}/public/img/rating/${slug}`;
};

export const getSdgTargetUrl = (slug: string) => {
  return `${assetBaseUrl}/public/img/sdg/sdg_target_${slug}.svg`;
};

//SEARCH PAGE ENDPOINTS
export const searchProjects = 'project/search';
export const searchFilters = 'project/search_filter_metadata';
export const searchPageCharts = 'project/stats';

//PROJECT DETAIL
export const projectDetails = '/project/details';
export const projectSdgData = '/project/sdg-rating-data';
export const relatedContent = '/project/related-content';
export const projectFollow = '/project/follow';
export const projectUnfollow = '/project/unfollow';
export const projectCreditSummary = '/project/annual-credit-summary';
export const requestEsrScreening = 'esr/report-request-form';

//WHERE TO BUY PAGE ENDPOINTS
export const whereToBuy = '/wheretobuy/all';
export const registerInterestRequest = '/wheretobuy/contact-vendor';

// RESOURCE PAGE ENDPOINTS
//PROJECT PAGE ENDPOINTS
export const projectGHGRatingData = '/project/ghg-rating-data';
export const resources = '/resource';

//RETIREE INSIGHTS ENDPOINTS
export const allRetireeInsights = '/retireeinsights/all';
export const filterMetadata = '/retireeinsights/filters_metadata';
export const projectRetireeInsights = '/retireeinsights/top_retirees';
export const projectRetireeTable = '/retireeinsights/project_table';
export const retireeAggregateData = '/retireeinsights/aggregate_stats';
export const retireeMarketShareData = '/retireeinsights/market_share';
export const retireeProjectPortfolio = '/retireeinsights/portfolio';
export const retireeBreakdownPieChart = '/retireeinsights/breakdown_stats';
export const retireeBreakdownTimeseriesChart = '/retireeinsights/breakdown_stats_timeseries';

//PROJECT ENDPOINTS
export const projectTypes = '/project_types';

//CONTACT PAGE ENDPOINTS
export const contact = '/user/contact-us';

//esr
export const esrSummary = '/esr/summary';
export const esrDetailSummary = '/esr/detailed-summary';
export const esrProjectComparison = '/esr/project-comparison';

//ACCOUNT REQUEST ENDPOINTS
export const accountRequest = '/user/account-request';
export const projectNames = '/project/names';
export const getProjectCreditAvailability = (projectId: string) =>
  `/project/${projectId}/credits-data`;

//PUBLIC REGISTER ENDPOINTS
export const validatePublicEmail = '/user/validate-email/public';
export const signupPublic = '/user/signup/public';
export const resetPasswordPublic = '/user/resend-email/public';
export const getCompanyTypes = '/user/company-types/public';
//SELLER INVENTORY ENDPOINTS
export const buyCreditsForm = '/wheretobuy/project/offers/form/buy';
export const sellCreditsForm = '/wheretobuy/project/offers/form/sell';
export const getProjectSellerOffersEndpoint = (projectUUID: string) =>
  `/wheretobuy/project/${projectUUID}/inventory`;

export const getSellerOffersSummary = (projectUUID: string) =>
  `/wheretobuy/project/${projectUUID}/seller-offers/summary`;

// PRICING AND SUPPLY ENDPOINTS
export const getPriceRangeDataByVintage = (cpId: string) =>
  `/wheretobuy/project/${cpId}/pricing/by-vintage`;
export const getTradePriceDistribution = (
  cpId: string,
  type: 'this_project' | 'all_projects' = 'this_project'
) => `/wheretobuy/project/${cpId}/pricing/distribution?type=${type}`;
export const getEstimatedTradePrice = (cpId: string) =>
  `/wheretobuy/project/${cpId}/pricing/estimated-trade-price`;
export const getPricingSummary = (projectUUID: string) =>
  `/wheretobuy/project/${projectUUID}/pricing/summary`;

// RATING COMPARISON ENDPOINT
export const getRatingComparison = (
  projectId: string,
  creditingPeriodId: string,
  ghgStandardCode: string,
  filter: 'this_project' | 'all_project' = 'this_project'
) =>
  `/project/rating-comparison?project_id=${projectId}&crediting_period_id=${creditingPeriodId}&ghg_standard_code=${ghgStandardCode}&filter=${filter}`;

//INSIGHTS HUB ENDPOINTS
export const pinnedPostAggregateData = 'project/insights-hub-pinned-post-data';

// DEVELOPER PORTAL ENDPOINTS
export const ratingSummaryRequestForm = 'project/rating-summary-request-form';
export const ratingNotificationRequestForm = 'project/rating-notification-request-form';

// COMPASS ENDPOINTS
export const ratingDistribution = '/project/compass/overview/rating-graph';
export const compassUpdates = '/compass/updates/list';
export const methodologyRiskGraph = '/project/compass/methodologies/risk-graph';
export const compass = '/compass';

// SUPPLY LINK ENDPOINTS
export const supplyLinkList = '/project/supply-link/list';
export const supplyLinkFilterMeta = '/project/supply-link/filter-metadata';
export const submitSupplyRequest = '/project/supply-request-form';
export const submitRequestForm = '/project/submit-request-form';

// EXPERT ADVISORY ENDPOINTS
export const advisoryForm = '/wheretobuy/advisory-form';

// PROJECT SCREENER (PDD ANALYZER) ENDPOINTS
// Spec: https://calyxglobal.atlassian.net/wiki/spaces/E/pages/56164353
export const screeningAll = '/project/screening/all';
export const screeningIncomplete = '/project/screening/incomplete';
export const screeningUpload = '/project/screening/upload';
export const screeningCreate = '/project/screening/create';
export const screeningEvents = (screeningId: string) => `/project/screening/${screeningId}/events`;
export const screeningDetails = (screeningId: string) =>
  `/project/screening/${screeningId}/details`;
export const screeningCancel = (screeningId: string) => `/project/screening/${screeningId}/cancel`;
export const screeningReport = (screeningId: string) => `/project/screening/${screeningId}/report`;
export const screeningInterestFormSubmit = '/project/screening/form-submit';
// Not in the main-flow spec (open question on credits) — keeping path consistent
// with the rest of the screener endpoints; flip if BE picks a different one.
export const screeningCredits = '/project/screening/credits';

// MY PLAN
// Counters + period dates land on the existing `/user/me` payload under
// `benefits`. Advisory-requests + inquiry surfaces persist customer-side
// form submissions so AMs see them in the admin Pending Inquiries panel.
export const myPlanDeepDiveRedeem = '/user/me/deep-dive/redeem';
export const myPlanSeats = '/user/me/seats';
// Single endpoint for every customer form (Use-a-Fastpass, Get-a-Quote both
// variants, Request-a-call). Server writes customer_inquiry + forwards to
// the matching Hubspot form per `source`.
export const myPlanInquiries = '/user/me/inquiries';
// Canonical advisory log (replaces deep-dive/requests for new surfaces):
// supports mode=dashboard (5-cap) + mode=full + filters (type, status, search).
export const myPlanAdvisoryRequests = '/user/me/advisory-requests';
export const myPlanAdvisoryReport = (id: string) => `/user/me/advisory-requests/${id}/report`;
